// extracted by mini-css-extract-plugin
module.exports = {"page":"_9pEki","pageContent":"Juvuh"};